module.exports = __webpack_public_path__ + "static/media/WVDF_Safeguarding_Policy_Behavior_Protocols.6eaeec57.pdf";